export function dockMode({ sourceBottom, anchorTop, height, viewport }) {
  if (sourceBottom > 0) return 'original';
  if (anchorTop + height <= 0) return 'compact';
  return anchorTop > viewport - height ? 'floating' : 'docked';
}
export function sectionScrollTop({ targetTop, scrollTop, toolbarHeight }) {
  return Math.max(0, targetTop + scrollTop - toolbarHeight - 12);
}
export function referenceDockMode({ infoTop, anchorTop, height, viewport }) {
  if (infoTop >= viewport - 40) return 'original';
  if (anchorTop + height <= 0) return 'compact';
  return anchorTop <= viewport - height ? 'docked' : 'floating';
}
export function absoluteDockTop({anchorTop,containerTop=0,containerScroll=0,borderTop=0}) {
  return anchorTop-containerTop+containerScroll-borderTop;
}

function initialize() {
  const tools = document.querySelector('[data-asap-scroll-tools]');
  const root = document.querySelector('.product-information');
  const facts = root?.querySelector('[data-asap-facts]');
  const grid = root?.querySelector('.product-information__grid');
  if (!tools || !root || !facts || !grid || tools.dataset.ready) return;
  tools.dataset.ready = 'true';
  root.setAttribute('data-asap-mobile-parity','');
  const scroller = document.querySelector('.page-wrapper') || window;
  const variants = JSON.parse(tools.querySelector('[data-scroll-variants]').textContent);
  const desktop = tools.querySelector('[data-scroll-desktop]');
  const mobile = tools.querySelector('[data-scroll-mobile]');
  const compact = tools.querySelector('[data-scroll-compact]');
  const compactSwatch=document.createElement('span');compactSwatch.className='asap-scroll-compact-swatch';compactSwatch.setAttribute('aria-hidden','true');compact.insertBefore(compactSwatch,compact.firstChild);
  document.body.classList.add('asap-scroll-enhanced');
  const giftTab = document.querySelector('[data-asap-tab][aria-controls^="Gifts-"]');
  if (giftTab && !giftTab.querySelector('.asap-gift-tab-icon')) {
    const icon=document.createElement('span');icon.className='asap-gift-tab-icon';icon.setAttribute('aria-hidden','true');
    icon.innerHTML='<svg viewBox="0 0 32 32" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="15" width="24" height="14" rx="2" fill="#ff6b6b" stroke="#e53935" stroke-width="1.5"/><rect x="3" y="11" width="26" height="5" rx="2" fill="#7c4dff" stroke="#512da8" stroke-width="1.5"/><path d="M14 11h4v18h-4z" fill="#ffeb3b"/><path d="M16 11C14 7 8 7 9 10c1 2 5 1 7 1ZM16 11c2-4 8-4 7-1-1 2-5 1-7 1Z" fill="#00e676" stroke="#00c853"/><circle cx="16" cy="11" r="2" fill="#ffeb3b" stroke="#fbc02d"/></svg>';
    ['#ff4d4d','#ffb300','#00c853','#2979ff','#ff4d4d','#ab47bc'].forEach((color,index)=>{const ray=document.createElement('i');ray.style.background=color;ray.style.setProperty('--angle',index*45+'deg');ray.style.setProperty('--delay',(.3+index*.035)+'s');icon.appendChild(ray);});
    giftTab.replaceChildren(icon,document.createTextNode('Gift'));
  }
  const slot = document.createElement('div');
  slot.className = 'asap-scroll-dock-slot';
  slot.setAttribute('aria-hidden', 'true');
  grid.appendChild(slot);
  const quantity = () => root.querySelector('input[name="quantity"]');
  const source = () => root.querySelector('.product-form-buttons');
  const add = () => root.querySelector('button[name="add"]');
  let frame = 0;
  let logosSource;
  let variantPending = false;
  let pendingVariantId;
  const setVisible = (element, visible) => { element.hidden = !visible; element.inert = !visible; };
  const sync = () => {
    const id = root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const current = variants.find(v => String(v.id) === id);
    const selectedColor=[...root.querySelectorAll('variant-picker input[type="radio"]:checked')].find(e=>/colou?r/i.test(e.dataset.optionName||''));
    const swatch=selectedColor?.closest('label')?.style.getPropertyValue('--asap-swatch')||'';
    if(compactSwatch.style.background!==swatch)compactSwatch.style.background=swatch;
    compactSwatch.hidden=!swatch;
    if (variantPending && id === pendingVariantId) variantPending = false;
    const reviewsButton = tools.querySelector('[data-scroll-target="reviews"]');
    reviewsButton.disabled = !document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, [data-asap-reviews]');
    reviewsButton.title = reviewsButton.disabled ? 'Reviews are not available on this page' : '';
    for (const select of tools.querySelectorAll('[data-scroll-variant]')) {
      if (!variantPending && id && select.value !== id) select.value = id;
    }
    for (const input of tools.querySelectorAll('[data-scroll-quantity]')) {
      if (document.activeElement !== input && quantity()) input.value = quantity().value;
      input.min = quantity()?.min || '1';
      input.step = quantity()?.step || '1';
      if (quantity()?.max) input.max = quantity().max; else input.removeAttribute('max');
    }
    for (const button of tools.querySelectorAll('[data-scroll-add],[data-scroll-buy]')) {
      button.disabled = !add() || add().disabled || root.querySelector('[data-asap-buy-now]')?.disabled || variantPending || current?.available === false;
    }
    const nativeError = root.querySelector('[data-asap-buy-error]:not([hidden]),.product-form-text__error:not(.hidden)');
    const errorOutput = tools.querySelector('[data-scroll-error]');
    const message = nativeError?.textContent?.trim() || '';
    if (errorOutput.textContent !== message) errorOutput.textContent = message;
    errorOutput.hidden = !message;
    const icons = root.querySelector('.asap-payment-icons');
    if (icons && icons !== logosSource) {
      const clone = icons.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
      tools.querySelector('[data-scroll-logos]').replaceChildren(clone);
      logosSource = icons;
    }
  };
  const paint = () => {
    frame = 0;
    if (!tools.isConnected) { cleanup(); return; }
    sync();
    const blocked = !!document.querySelector('dialog[open], shopify-chat[open], header-drawer details[open], [data-asap-member-popup].is-open, .asap-member-modal.is-open') || document.documentElement.hasAttribute('scroll-lock') || document.body.style.overflow === 'hidden';
    const small = matchMedia('(max-width:749px)').matches;
    const barHeight = mobile.offsetHeight || Number(tools.dataset.mobileHeight) || 180;
    if (mobile.offsetHeight) tools.dataset.mobileHeight = String(mobile.offsetHeight);
    slot.style.height = small ? barHeight + 'px' : '0px';
    const mode = small ? referenceDockMode({ infoTop: root.querySelector('.product-details')?.getBoundingClientRect().top ?? Infinity, anchorTop: slot.getBoundingClientRect().top, height: barHeight, viewport: innerHeight }) : 'desktop';
    tools.dataset.mode = mode;
    setVisible(desktop, !blocked && innerWidth >= 990 && (source()?.getBoundingClientRect().bottom ?? Infinity) <= 0);
    setVisible(mobile, !blocked && small && ['floating', 'docked'].includes(mode));
    setVisible(compact, !blocked && small && facts.getBoundingClientRect().top <= innerHeight - 64);
    const docked=mode==='docked';
    mobile.style.position=docked?'absolute':'fixed';
    mobile.style.width=document.documentElement.clientWidth+'px';
    if(docked){
      const parent=mobile.offsetParent,bounds=parent?.getBoundingClientRect();
      const top=absoluteDockTop({anchorTop:slot.getBoundingClientRect().top,containerTop:bounds?.top||0,containerScroll:parent?.scrollTop||0,borderTop:parent?.clientTop||0})+'px';
      if(mobile.style.top!==top)mobile.style.top=top;
      mobile.style.left=((parent?.scrollLeft||0)-(bounds?.left||0)-(parent?.clientLeft||0))+'px';
      mobile.style.bottom='auto';
    }else{mobile.style.top='auto';mobile.style.bottom='0px';mobile.style.left='0px';}
    document.body.classList.toggle('asap-scroll-compact-active', !compact.hidden);
    slot.hidden = !small;
    window.dispatchEvent(new Event('asap:purchase-layout'));
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
  const changeVariant = async select => {
    const variant = variants.find(v => String(v.id) === select.value);
    const picker = root.querySelector('variant-picker');
    if (!variant || !picker) return;
    const fields = [...picker.querySelectorAll('fieldset')];
    const selects = [...picker.querySelectorAll('select')];
    let changed;
    variant.options.forEach((value, index) => {
      const radio = fields[index] && [...fields[index].querySelectorAll('input[type="radio"]')].find(e => e.value === value);
      if (radio && !radio.checked) { picker.updateSelectedOption(radio); changed = radio; }
      const nativeSelect = selects[index];
      if (!fields.length && nativeSelect && nativeSelect.value !== value) {
        nativeSelect.value = value; picker.updateSelectedOption(nativeSelect); changed = nativeSelect;
      }
    });
    if (changed) {
      variantPending = true; pendingVariantId = String(variant.id); sync();
      changed.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(() => { if (pendingVariantId === String(variant.id)) variantPending = false; schedule(); }, 8000);
    }
    schedule();
  };
  tools.addEventListener('change', event => {
    if (event.target.matches('[data-scroll-variant]')) changeVariant(event.target);
    if (event.target.matches('[data-scroll-quantity]') && quantity()) {
      const native = quantity(), value = Number(event.target.value);
      if (event.target.checkValidity() && Number.isFinite(value) && value >= Number(native.min || 1) && (!native.max || value <= Number(native.max))) {
        native.value = String(value); native.dispatchEvent(new Event('change', { bubbles: true })); native.dispatchEvent(new Event('blur', { bubbles: true }));
      }
      event.target.value = native.value; schedule();
    }
  });
  tools.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.dataset.scrollStep) { root.querySelector('.quantity-selector button[name="' + (button.dataset.scrollStep === '1' ? 'plus' : 'minus') + '"]')?.click(); schedule(); }
    if (button.hasAttribute('data-scroll-add') && !button.disabled) add()?.click();
    if (button.hasAttribute('data-scroll-buy') && !button.disabled) root.querySelector('[data-asap-buy-now]')?.click();
    if (button.hasAttribute('data-scroll-chat')) {
      const findButton = shadow => {
        if (!shadow) return null;
        const direct = shadow.querySelector('button[aria-label="Chat"],button.activator');
        if (direct) return direct;
        for (const node of shadow.querySelectorAll('*')) { const nested = findButton(node.shadowRoot); if (nested) return nested; }
        return null;
      };
      findButton(document.querySelector('shopify-chat')?.shadowRoot)?.click();
    }
    if (button.dataset.scrollTarget) {
      const type = button.dataset.scrollTarget;
      const sections = [...document.querySelectorAll('main>.shopify-section')].filter(e => !e.contains(root) && e.getBoundingClientRect().height > 40);
      const target = type === 'specs' ? [...document.querySelectorAll('main details')].find(e => /specs|product details|specifications/i.test(e.querySelector('summary')?.textContent || '')) || sections.find(e => /specifications/i.test(e.innerText)) : type === 'reviews' ? document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, [data-asap-reviews]') : sections[0];
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
      tools.querySelectorAll('[data-scroll-target]').forEach(e => e.setAttribute('aria-pressed', String(e === button)));
      scroller.scrollTo({ top: sectionScrollTop({ targetTop: target.getBoundingClientRect().top, scrollTop: scroller === window ? scrollY : scroller.scrollTop, toolbarHeight: desktop.offsetHeight }), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    }
  });
  const observer = new MutationObserver(schedule);
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value', 'checked'] });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  const overlays=new MutationObserver(schedule);
  overlays.observe(document.body,{attributes:true,subtree:true,attributeFilter:['open']});
  overlays.observe(document.documentElement,{attributes:true,attributeFilter:['scroll-lock']});
  const resize = new ResizeObserver(schedule);
  resize.observe(root); resize.observe(facts); resize.observe(mobile);
  document.addEventListener('change', schedule);
  document.addEventListener('variant:update', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  if (scroller !== window) scroller.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  const cleanup = () => {
    observer.disconnect(); overlays.disconnect(); resize.disconnect(); cancelAnimationFrame(frame);
    document.removeEventListener('change', schedule); document.removeEventListener('variant:update', schedule);
    window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
    if (scroller !== window) scroller.removeEventListener('scroll', schedule);
    document.body.classList.remove('asap-scroll-compact-active','asap-scroll-enhanced'); slot.remove();
    root.removeAttribute('data-asap-mobile-parity');
  };
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(tools)) cleanup(); });
  schedule();
}
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
}
